import type { BrandingTheme } from "./theme.types";
import sentinelsLogoWhite from "@/assets/brand/sentinels-white-tagline-hub.png";
import sentinelsLogoDark from "@/assets/brand/sentinels-tagline-hub.png";

/**
 * Default Sentinels Hub theme — navy sidebar with green accents.
 * Used for the admin shell and as fallback when an organization
 * has no branding_config defined.
 *
 * Logo paths use Vite imports (hashed at build time) instead of
 * raw /assets/ paths which don't exist in the production build.
 */
export const SENTINELS_THEME: BrandingTheme = {
  sidebar_bg: "#221B36",
  sidebar_text: "#FFFFFF",
  sidebar_active_bg: "rgba(0,166,81,0.15)",
  sidebar_active_indicator: "#00A651",
  accent_primary: "#221B36",
  accent_secondary: "#00A651",
  brand_primary: "#221B36",
  logos: {
    sidebar: sentinelsLogoWhite,
    header: sentinelsLogoDark,
  },
  meta: {
    app_title: "Sentinels Hub",
  },
};
